import React, { useState } from 'react';
import { QuestionBank } from './QuestionBank';
import { TestManagement } from './TestManagement';
import { ExamManagement } from './ExamManagement';
import { Announcements } from './Announcements';

export const ContentManagement: React.FC = () => {
  const [activeSection, setActiveSection] = useState('questions');

  const sections = [
    { id: 'questions', label: 'Question Bank', icon: '❓' },
    { id: 'tests', label: 'Test Management', icon: '📝' },
    { id: 'exams', label: 'Exam Management', icon: '🎓' },
    { id: 'announcements', label: 'Announcements', icon: '📢' }
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Content Management</h2>
        <p className="text-gray-600">Manage questions, tests, exams, and announcements</p>
      </div>

      <div className="mb-6">
        <nav className="flex space-x-4">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-colors ${
                activeSection === section.id
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
              }`}
            >
              <span>{section.icon}</span>
              <span>{section.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="bg-white rounded-lg shadow">
        {activeSection === 'questions' && <QuestionBank />}
        {activeSection === 'tests' && <TestManagement />}
        {activeSection === 'exams' && <ExamManagement />}
        {activeSection === 'announcements' && <Announcements />}
      </div>
    </div>
  );
};